var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimUnderReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clain Under Review Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4399 42.6224L60.9799 48.8174C62.0982 49.7358 62.2591 51.3866 61.3407 52.5041C60.4224 53.6216 58.7716 53.7841 57.6541 52.8658L50.1141 46.6699M48.6116 48.4989L54.9424 40.7939M51.7773 44.6464L48.6856 42.1064M44.2692 42.7933V55.3033C44.2692 56.2408 43.51 57 42.5725 57H19.6967C18.7592 57 18 56.2408 18 55.3033V18.6975C18 17.76 18.7592 17 19.6967 17H42.5725C43.51 17 44.2692 17.76 44.2692 18.6975V20.4908M31.6374 27.5822H39.9866M29.1943 31.7223H42.1243M28.6848 35.8626H42.124M30.9253 40.0028H39.2736M45.5785 26.453C49.8977 30.0022 50.5227 36.3805 46.9735 40.6997C43.4243 45.0197 37.046 45.6439 32.7268 42.0955C28.4077 38.5464 27.7827 32.168 31.331 27.8489C34.8802 23.5289 41.2585 22.9047 45.5785 26.453Z",
    stroke: "#000000",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimUnderReview);
export default __webpack_public_path__ + "static/media/claim-under-review.c85a18801ecf55d345920506bf2529e1.svg";
export { ForwardRef as ReactComponent };